export default {
    AREA_FETCH_ALL_SUCCESS: 'AREA_FETCH_ALL_SUCCESS',

    AREA_CREATE: 'AREA_CREATE',
    AREA_CREATE_FAILED: 'AREA_CREATE_FAILED',
    AREA_CREATE_SUCCESS: 'AREA_CREATE_SUCCESS',

    AREA_ADD_INSTITUTION: 'AREA_ADD_INSTITUTION',
    AREA_ADD_INSTITUTION_FAILED: 'AREA_ADD_INSTITUTION_FAILED',
    AREA_ADD_INSTITUTION_SUCCESS: 'AREA_ADD_INSTITUTION_SUCCESS',
    AREA_REMOVE_INSTITUTION: 'AREA_REMOVE_INSTITUTION',
    AREA_REMOVE_INSTITUTION_FAILED: 'AREA_REMOVE_INSTITUTION_FAILED',
    AREA_REMOVE_INSTITUTION_SUCCESS: 'AREA_REMOVE_INSTITUTION_SUCCESS',
};
